import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import type { TopUserItem } from "@/lib/types";

export function TopUsersChart({ data }: { data: TopUserItem[] }) {
  if (data.length === 0) {
    return (
      <div className="flex h-[280px] items-center justify-center text-sm text-muted-foreground">
        데이터 없음
      </div>
    );
  }
  // 가로 막대로 표시 (이름이 길어도 잘 보임)
  return (
    <ResponsiveContainer width="100%" height={Math.max(220, data.length * 32)}>
      <BarChart
        layout="vertical"
        data={data}
        margin={{ top: 8, right: 24, bottom: 0, left: 24 }}
      >
        <CartesianGrid strokeDasharray="3 3" opacity={0.3} />
        <XAxis type="number" fontSize={11} />
        <YAxis
          type="category"
          dataKey={(it: TopUserItem) => it.user_name || it.user_id}
          fontSize={11}
          width={90}
        />
        <Tooltip />
        <Bar dataKey="total" name="질의 수" fill="#2563eb" radius={[0, 4, 4, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
}
